// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"8330bb93","256":"698d2e6d"}[chunkId] + ".chunk.js";
};